import { useNavigate } from "@tanstack/react-router"
import { useEffect, useState } from "react"

import { trpc } from "../lib/trpc"

const SlackCallbackScreen = () => {
  const navigate = useNavigate()
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading")
  const [error, setError] = useState<string | null>(null)

  // Mock user ID - in a real app, you'd get this from your auth context
  const userId = "current-user-id" // TODO: Replace with actual user ID from auth context

  const handleOAuthCallback = trpc.slack.handleOAuthCallback.useMutation({
    onSuccess: (data) => {
      console.log("Slack OAuth successful:", data)
      setStatus("success")
      // Redirect to integrations page after a brief success message
      setTimeout(() => {
        navigate({ to: "/integrations" })
      }, 2000)
    },
    onError: (error) => {
      console.error("Slack OAuth error:", error)
      setError(error.message)
      setStatus("error")
    },
  })

  useEffect(() => {
    // Extract code and state from URL parameters
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get("code")
    const state = urlParams.get("state")
    const error = urlParams.get("error")

    if (error) {
      setError(`OAuth error: ${error}`)
      setStatus("error")
      return
    }

    if (!code) {
      setError("No authorization code received")
      setStatus("error")
      return
    }

    // Exchange code for token
    handleOAuthCallback.mutate({
      code,
      state: state || undefined,
      userId,
    })
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-foregroundx">
      <div className="max-w-md w-full bg-background rounded-lg shadow p-6">
        <div className="text-center">
          {status === "loading" && (
            <>
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
              <h2 className="text-xl font-semibold  mb-2">Connecting to Slack...</h2>
              <p className="">Please wait while we complete your Slack integration.</p>
            </>
          )}

          {status === "success" && (
            <>
              <div className="text-green-600 text-6xl mb-4">✅</div>
              <h2 className="text-xl font-semibold  mb-2">Slack Connected Successfully!</h2>
              <p className=" mb-4">Your Slack workspace has been connected to AIX Command Center.</p>
              <p className="text-sm text-gray-500">Redirecting to integrations page...</p>
            </>
          )}

          {status === "error" && (
            <>
              <div className="text-destructive text-6xl mb-4">❌</div>
              <h2 className="text-xl font-semibold  mb-2">Connection Failed</h2>
              <p className=" mb-4">{error || "Something went wrong while connecting to Slack."}</p>
              <button
                onClick={() => navigate({ to: "/integrations" })}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
              >
                Return to Integrations
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default SlackCallbackScreen
